import { Component, input, model, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Icon } from "@malirang/front-share";

@Component({
    selector: "app-document-box-accordian",
    templateUrl: "./document-box-accordian.html",
    styleUrls: ["./document-box-accordian.css"],
    imports: [CommonModule, Icon],
})
export class DocumentBoxAccordian {
    title = input<string>("");
    open = model(true);

    toggle() {
        this.open.set(!this.open());
    }
}
